var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z",
    fill: "#4FD190"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1599 31.1592C20.7599 31.1592 20.3799 30.9992 20.0999 30.7192L14.4399 25.0592C13.8599 24.4792 13.8599 23.5192 14.4399 22.9392C15.0199 22.3592 15.9799 22.3592 16.5599 22.9392L21.1599 27.5392L31.4399 17.2592C32.0199 16.6792 32.9799 16.6792 33.5599 17.2592C34.1399 17.8392 34.1399 18.7992 33.5599 19.3792L22.2199 30.7192C21.9399 30.9992 21.5599 31.1592 21.1599 31.1592Z",
    fill: "#4FD190"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.811441dd40cc922bbcdd838c3ceeac04.svg";
export { ForwardRef as ReactComponent };